import PageComponent from 'components/Dashboard/PageComponent'
import { DashboardTitle } from '../DashboardTitleContext'
import VideoQueue from './VideoQueue'

const VideoQueuePage: PageComponent = () => {
  return (
    <div className="container">
      <DashboardTitle title="Video Supervision Queue" />

      <VideoQueue title="Video Queue" />

      <VideoQueue queueName="VideoQueue_InProgress" title="In Progress calls" />

      <VideoQueue queueName="VideoQueue_Completed" title="Recently completed calls" />
    </div>
  )
}

VideoQueuePage.displayName = 'Video Queue'
VideoQueuePage.path = '/video-queue'

export default VideoQueuePage
